// Internet Explorer 11 requires polyfills and partially supported by this project.
// import 'react-app-polyfill/ie11';
// import 'react-app-polyfill/stable';
import 'regenerator-runtime';
import { createRoot, type Container } from 'react-dom/client';
import * as Iconify from '@iconify/react';
import WiseIconPack from '@wise/icons';
import './i18n';
import './styles/index.css';
import App from 'app/App';
// import * as serviceWorker from './serviceWorker';
import reportWebVitals from './reportWebVitals';

Iconify.addAPIProvider('wise', {
	resources: ['https://iconify.poloinnovativo.it']
});
Iconify.addCollection(WiseIconPack);
Iconify.disableCache('local');

const root = createRoot(document.getElementById('root') as Container);
root.render(<App />);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: http://bit.ly/CRA-PWA
// serviceWorker.unregister();
// serviceWorker.register();

reportWebVitals();
